import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import ScrollAnimationInit from './components/ScrollAnimationInit';

// Personal pages
import Personal from './pages/Personal';
import Internet from './pages/personal/Internet';
import TV from './pages/personal/TV';
import Telefonie from './pages/personal/Telefonie';
import Supraveghere from './pages/personal/Supraveghere';
import Intercom from './pages/personal/Intercom';

// Business pages
import Business from './pages/Business';
import BusinessInternet from './pages/business/Internet';
import Hosting from './pages/business/Hosting';
import Networks from './pages/business/Networks';
import Security from './pages/business/Security';

// Shop pages
import Shop from './pages/Shop';
import Routers from './pages/shop/Routers';
import Cameras from './pages/shop/Cameras';
import Intercoms from './pages/shop/Intercoms';
import Accessories from './pages/shop/Accessories';

// Additional pages
import About from './pages/About';
import News from './pages/News';
import Contact from './pages/Contact';
import SendMessage from './pages/SendMessage';

function App() {
  return (
    <Layout>
      <ScrollToTop />
      <ScrollAnimationInit />
      <Routes>
        {/* Personal routes */}
        <Route path="/" element={<Personal />} />
        <Route path="/personal/internet" element={<Internet />} />
        <Route path="/personal/tv" element={<TV />} />
        <Route path="/personal/telefonie" element={<Telefonie />} />
        <Route path="/personal/supraveghere" element={<Supraveghere />} />
        <Route path="/personal/intercom" element={<Intercom />} />

        {/* Business routes */}
        <Route path="/business" element={<Business />} />
        <Route path="/business/internet" element={<BusinessInternet />} />
        <Route path="/business/hosting" element={<Hosting />} />
        <Route path="/business/networks" element={<Networks />} />
        <Route path="/business/security" element={<Security />} />

        {/* Shop routes */}
        <Route path="/shop" element={<Shop />} />
        <Route path="/shop/routers" element={<Routers />} />
        <Route path="/shop/cameras" element={<Cameras />} />
        <Route path="/shop/intercoms" element={<Intercoms />} />
        <Route path="/shop/accessories" element={<Accessories />} />

        {/* Additional routes */}
        <Route path="/about" element={<About />} />
        <Route path="/news" element={<News />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/send-message" element={<SendMessage />} />
      </Routes>
    </Layout>
  );
}

export default App;
